
import {Component, Vue} from "vue-property-decorator";

import Pagination from "@/components/Pagination/index.vue";
import {
  getSuppliersList,
  putResetInventory
} from "@/api/inquiry";
import {
  getCustomerInventory,
  getPiInfo,
  getExcessiveInventory,
} from "@/api/proforma";
import Template from "@/views/system-management/template/index.vue";
import NormalUsedInventory from "@/views-oms/sales-order-management/order/customer-inventory/components/Inventory.vue";
import {split} from "lodash";
import {Message} from "element-ui";

@Component({
  name: "quotationDetails",
  components: {
    NormalUsedInventory,
    Template,
    Pagination,
    Inventory: () => import("./components/Inventory.vue"),
  },
})
export default class extends Vue {
  // 是否显示所有产品号码
  private showNumber = false;
  private showDesc = false;
  private listLoading = true;
  private showInventory = false;

  private id = "";
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public piInfo = {} as any;
  private listParam = {
    refNumber: null,
    supplier: null,
    hqProductName: null,
    productName: null,
  };
  public searchForm = [
    {
      label: "号码查询",
      prop: "refNumber",
      key: "refNumber",
      type: "input",
      value: "",
      placeholder: "请输入产品号码",
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      type: "input",
      value: "",
      placeholder: "请输入华强品名",
    },
    {
      label: "PRODUCT NAME",
      prop: "productName",
      key: "productName",
      type: "input",
      value: "",
      placeholder: "请输入PRODUCT NAME",
    },
    {
      label: "供应商",
      prop: "supplier",
      key: "supplier",
      type: "select",
      value: "",
      placeholder: "",
      remote_method: this.getSuppliersList,
      remote: true,
      clearable: true,
      options: [],
      resetKey: {label: "abbreviation", value: "id"},
    },
  ];

  public customerInfo = {} as any;
  public customerInfoFields = [
    {
      label: "客人信息",
      key: "customerAbbr",
    },
    {
      label: "客人国家",
      key: "customerNation",
    },
    {
      label: "长期定金",
      key: "longTermDeposit",
    },
    {
      label: "交易公司",
      key: "company",
    },
    {
      label: "库存总金额",
      key: "totalInventoryValue",
    },
  ] as any;

  created() {
    this.id = this.$route.query.id as string;
    this.init();
  }

  activated() {
    this.init();
  }

  private init() {
    this.getPiInfo();
    this.getList();
  }

  private async getPiInfo() {
    const res: any = await getPiInfo(this.id);
    this.piInfo = res;
  }

  private async getSuppliersList(name = "") {
    const res: any = await this.getSuppliers(name);
    this.searchForm[3].options = res;
  }

  private async getSuppliers(name = "") {
    const res: any = await getSuppliersList({abbreviation: name});
    return res;
  }

  private goBack() {
    this.$router.go(-1);
  }


  public querySearch(data) {
    this.table.pageNumber = 1;
    this.listParam = data && data !== "reset" ? data : {};
    this.getList();
  }

  private async putResetInventory() {
    if (this.selectedRows.length == 0) {
      Message.error({
        message:"请选择需要重置的型号"
      })
      return;
    }
    let ids = this.selectedRows.filter(item => item.id)
        .map(item => item.id);
    this.$confirm("确定重置吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(async () => {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          await putResetInventory(ids).then(async res => {
            this.$notify({
              title: "成功",
              message: "重置成功！",
              type: "success",
              duration: 2000,
            });
            loading.close();
           await this.getList();
           await this.getPiInfo();
          }).catch(err => {
            console.error(err);
            loading.close();
          })
        })
        .catch((err) => {
          console.error(err);
        });
  }

  public loading: Boolean = false;
  private modelRes: [] = [];
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = false;
    const {total, list}: any = await getCustomerInventory(this.id, params);
    this.table.total = +total;
    this.table.list = list;
    if (this.table.list.length > 0) {
      this.modelRes = list[0].modelRes;
    }
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  private handlerShowDesc() {
    this.showDesc = !this.showDesc;
  }

  private  handlerShowNumber() {
    this.showNumber = !this.showNumber;
  }

  private inventories = [];
  private remaining = 0;
  private curPiInfoId = '';

  /**
   * 找出已经使用/可用的库存。
   * @param row
   * @private
   */
  private async handleView(row) {
      let strings = split(row.useInventoryProgress, "/");
      this.remaining = Number(strings[1]) - Number(strings[0]);
      let inventories: any = await getExcessiveInventory(row.id);
      this.inventories = inventories;
      this.curPiInfoId = row.id
      this.showInventory = true;
  }

  /**
   * 选择库存确定的回调事件
   * @private
   */
  private async handleSuccess() {
    this.showInventory = false;
    await this.getList();
    await this.getPiInfo();
  }

  /**
   * 获取当前行的型号
   * @param row
   * @param modelType
   * @private
   */
  private getCurRowModel(row, modelType) {
    if (row.modelRes.find((item) => item.typeId === modelType).number === undefined) {
      Message.error({
        message: "未找到对应的号码类型",
        duration: 2000
      })
    } else {
      return row.modelRes.find((item) => item.typeId === modelType).number;
    }
  }

  /**
   * 记录选择的行。
   * @private
   */
  private selectedRows = []
  private handleSelectionChange(val) {
    this.selectedRows = val;
  }

  /**
   * 未使用过库存的不允许被勾选。
   * @param row
   * @private
   */
  private checkCanSelect(row) {
    return row.totalInventoryValue > 0;
  }
}
